<template>
  <f7-page>
    <navbar :text="`${$t('Utilities_Title')} > ${$t('Vademecum_Title')}`" />
    <ProductDetail :product-detail="phytosanitaryProductDetail[0].productDetail" />
    <UsesDosesAuthPlague :uses-doses-auth="phytosanitaryProductDetail[0].usesDosesAuth" />
    <product-warning>
      {{ $t('Vademecum_product_warning_prod_detail') }}
    </product-warning>
    <f7-block-footer
      class="go-back-button"
    >
      <f7-button
        class="dx-btn-cancel btnBack"
        type="default"
        text-color="grey"
        styling-mode="outlined"
        @click="goToVademecum"
      >
        {{ $t("Go_Back") }}
      </f7-button>
    </f7-block-footer>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ProductDetail from '../../../components/utilities/vademecum/phytosanitaryProductDetail/productDetail/index.vue';
import UsesDosesAuthPlague from '../../../components/utilities/vademecum/phytosanitaryProductDetail/usesDosesAuthPlague/index.vue';
import navbar from '../../../components/NavBar.vue';
import ProductWarning from '@/components/utilities/vademecum/productWarning/index.vue';

export default {
  name: 'ViewPhytosanitaryProductPlagueDetail',
  components: {
    navbar,
    ProductDetail,
    UsesDosesAuthPlague,
    ProductWarning,
  },
  computed: {
    ...mapState('Vademecum', ['phytosanitaryProductDetail']),
  },
  methods: {
    goToVademecum() {
      this.clearForcedProductDetail();
      this.$f7.views.main.router.navigate('/vademecum/phytosanitary/', { reloadCurrent: true });
    },

    ...mapActions('Vademecum', ['clearForcedProductDetail']),
  },
};
</script>
